import { render, staticRenderFns } from "./PartnershipK.vue?vue&type=template&id=0ded2b97&scoped=true"
import script from "./PartnershipK.vue?vue&type=script&lang=js"
export * from "./PartnershipK.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ded2b97",
  null
  
)

export default component.exports